module.exports = __webpack_public_path__ + "static/media/arm.7cd733fa.jpg";